<template>
  <div
      :id="id"
      class="modal fade xp-video-popup"
      :class="{ show: show }"
      tabindex="-1"
      aria-labelledby="articleModalLabel"
      aria-modal="true"
      role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h3 v-if="title" class="modal-title" :id="`${id}-title`">{{ title }}</h3>
          <a class="xp-cls cls" @click.prevent="$emit('close')">Close <i class="fa fa-angle-right"/></a>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col col-xs-10">

              <slot />

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ModalShell",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: String,
      required: false,
      default: 'articleModal'
    },
    title: {
      type: String,
      required: false,
      default: ''
    },

  },
}
</script>


<style scoped lang="scss">
.modal {
  &.show {
    display: block;
  }
}
</style>